<template>
  <div
    class="start_price"
    v-if="nowAcvitity.promotionName"
    :class="{ activeType: nowAcvitity.promotionLabel === 2 }"
  >
    <div class="left_price">
      <div class="sale_price">
        <span>￥</span
        ><b>{{
          dealPrice(nowAcvitity.state === 0 ? nowAcvitity.price : nowAcvitity.promotionPrice)
            
        }}</b>
        <p v-if="nowAcvitity.state === 1">限时</p>
      </div>
      <div class="origin_price">
        <b v-if="nowAcvitity.state === 0">￥{{ nowAcvitity.promotionPrice }}</b>
        <s v-else>￥{{ nowAcvitity.price }}</s>
        <span class="sale_num" v-if="nowAcvitity.state === 1"
          >{{ productDetail.realSales + productDetail.initialSales }}人已抢购</span
        >
      </div>
    </div>
    <div class="right_time">
      <div class="time1" v-if="timeType === 1">
        {{ times }}<br />
        即将开始
      </div>
      <div class="time2" v-else>
        <p>{{ nowAcvitity.state === 0 ? '活动开始倒计时' : '活动结束倒计时' }}</p>
        <div>
          <b class="day" v-if="times.d !== '00'">{{ times.d }}</b>
          <b>{{ times.h }}</b>
          <b>{{ times.m }}</b>
          <b>{{ times.s }}</b>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { priceCount, dateTime, timerCount, replaceHyphens,priceFilterFloat } from '@/utils/tools';

export default {
  components: {},
  data() {
    return {
      times: '', // 时间展示
      timeType: 0, // 1 大于3天 2小于3天
      timers: null, // 定时器
    };
  },
  props: {
    productDetail: {
      type: Object,
      default: () => {},
    },
    nowAcvitity: {
      type: Object,
      default: () => {},
    },
    currentTime: {
      type: Number,
      default: 0,
    },
  },

  computed: {},
  watch: {
    nowAcvitity: {
      handler() {
        this.checkTime();
      },
      immediate: true,
      deep: true,
    },
  },
  created() {},
  mounted() {},
  destroyed() {
    clearInterval(this.timers);
  },
  methods: {
    // 价格小数位处理
    calculationPrice(price) {
      return priceCount(price);
    },
    // 校验开始/结束时间是否大于3天 区分展示时间ui
    checkTime() {
      let startTime = '';
      // alert(this.nowAcvitity.state);
      if (this.nowAcvitity.state === 0) {
        // 未开始
        startTime = new Date(replaceHyphens(this.nowAcvitity.startTime)).getTime();
      } else {
        // 进行中
        startTime = new Date(replaceHyphens(this.nowAcvitity.endTime)).getTime();
        // alert(startTime);
      }
      let temp = startTime - this.currentTime + 1000;

      if (temp / (1000 * 60 * 60 * 24) > 3 && this.nowAcvitity.state === 0) {
        this.timeType = 1;
        this.times = `${dateTime(startTime).month}月${dateTime(startTime).day}日${
          dateTime(startTime).h
        }:${dateTime(startTime).m}`;
      } else {
        this.timeType = 2;
        this.times = timerCount(temp, 2);
        this.timers = setInterval(() => {
          temp -= 1000;
          if (temp > 0) {
            this.times = timerCount(temp, 2);
          } else {
            // 倒计时结束  重新拉取接口请求
            clearInterval(this.timers);
            this.$emit('triggerGetActive', true);
          }
        }, 1000);
      }
    },
  },
};
</script>
<style scoped lang="scss">
// 直降

.start_price {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 444px;
  height: 67px;
  padding: 0 11px;
  background: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/ebook/discount-bg1.png')
    no-repeat;
  background-size: 100%;
  .left_price {
    .sale_price {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      span {
         position: relative;
         top: 6px;
        color: #fff;
        font-size: 18px;
      }
      b {
        color: #fff;
        font-weight: 600;
        font-size: 33px;
      }
      p {
        width: 43px;
        height: 24px;
        margin-left: 7px;
        color: #FF0139;
        font-weight: 500;
        font-size: 18px;
        line-height: 24px;
        text-align: center;
        background: #fff;
        border-radius: 5px;
      }
    }
    .origin_price {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      span,
      s,
      b {
        color: #fff;
        font-size: 18px;
      }
      span.sale_num {
        padding-left: 10px;
      }
    }
  }
  .right_time {
    .time1 {
      color: #954505;
      font-size: 22px;
      text-align: center;
    }
    .time2 {
      p {
        padding-bottom: 3px;
        color: #954505;
        font-size: 22px;
        text-align: right;
      }
      div {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        b.day {
          &::after {
            top: 15px;
            right: -20px;
            font-size: 18px;
            content: '天';
          }
        }
        b {
          position: relative;
          display: inline-block;
          width: 29px;
          height: 29px;
          margin-left: 22px;
          color: #fff;
          font-weight: bold;
          font-size: 18px;
          line-height: 29px;
          text-align: center;
          background: #954505;
          border-radius: 4px;
          &::after {
            position: absolute;
            top: 15px;
            right: -15px;
            display: inline-block;
            color: #954505;
            font-weight: 500;
            font-size: 22px;
            transform: translateY(-50%);
            content: ':';
          }
        }

        b:last-child {
          &::after {
            display: none;
          }
        }
      }
    }
  }
}
</style>
